import { ROUTE_PATHS } from './navigation';

const systemsConfig = [
  {
    key: 'koleave',
    title: 'Koleave',
    subtitle: 'Izin, mesai ve vardiya islemleri',
    icon: 'bx bx-calendar-check',
    url: process.env.REACT_APP_KOLEAVE_URL,
    fallbackPath: `${ROUTE_PATHS.documents}?kategori=form-sablon`,
    fallbackLabel: 'Erisim rehberini ac',
    helperText: 'Yetki ve kullanim akisi IK tarafindan bu kanal uzerinden duyurulur.'
  },
  {
    key: 'pdks',
    title: 'PDKS / Giris Sistemi',
    subtitle: 'Gecis ve devam bilgileri',
    icon: 'bx bx-door-open',
    url: process.env.REACT_APP_PDKS_URL,
    fallbackPath: `${ROUTE_PATHS.documents}?kategori=politika-prosedur`,
    fallbackLabel: 'Kullanim akisini goruntule',
    helperText: 'Kart tanimlari, gecis kurallari ve vardiya esaslari merkezi dokumanlarda yer alir.'
  },
  {
    key: 'forms',
    title: 'IK Form Merkezi',
    subtitle: 'Dilekce, onboarding ve surec dokumanlari',
    icon: 'bx bx-file',
    fallbackPath: `${ROUTE_PATHS.documents}?kategori=form-sablon`,
    fallbackLabel: 'Form merkezine git',
    helperText: 'Tum standart IK formlari tek noktadan yonetilir.'
  }
];

export const hrSystems = systemsConfig.map((system) => {
  const hasExternalUrl = Boolean(system.url);

  return {
    ...system,
    href: hasExternalUrl ? system.url : system.fallbackPath,
    isExternal: hasExternalUrl,
    ctaLabel: hasExternalUrl ? 'Sistemi ac' : system.fallbackLabel
  };
});

export const onboardingJourney = [
  {
    id: 'preboarding',
    title: 'Preboarding',
    owner: 'IK Operasyon',
    timeline: 'Ise baslamadan once',
    tasks: ['Kurum hesabi acilisi', 'Evrak kontrolu', 'Ilk gun planinin paylasilmasi']
  },
  {
    id: 'first-day',
    title: 'Ilk gun',
    owner: 'Yoneticisi ve IK',
    timeline: 'Gun 1',
    tasks: ['Kart ve giris tanimlari', 'Ekip tanitimi', 'Temel sistemlere erisim']
  },
  {
    id: 'first-week',
    title: 'Ilk hafta',
    owner: 'Birim yoneticisi',
    timeline: 'Gun 2-5',
    tasks: ['Rol beklentileri', 'Toplanti plani', 'Is guvenligi ve surec dokumanlari']
  },
  {
    id: 'first-month',
    title: 'Ilk ay',
    owner: 'IK Is Ortagi',
    timeline: '30 gun',
    tasks: ['Uyum gorusmesi', 'Gelisim ihtiyaclari', 'Deneme sureci takip notlari']
  }
];

export const onboardingChecklist = [
  'Koleave erisimi ve kullanici hesabi dogrulamasi',
  'Kart basimi, yemekhane tanimlari ve acil durum kaydi',
  'Departman oryantasyon plani ve ilk hafta toplantilari',
  'Is sagligi, guvenligi ve sirket prosedurlerinin paylasimi'
];
